"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Resolved = exports.Rejected = exports.reject = exports.resolve = void 0;
const resolve = (value) => new Resolved(value);
exports.resolve = resolve;
const reject = (err) => new Rejected(err);
exports.reject = reject;
class Rejected {
    constructor(error) {
        this.value = undefined;
        this.error = error;
    }
    get isResolved() {
        return false;
    }
    get isRejected() {
        return true;
    }
    then(_f) {
        return exports.reject(this.error);
    }
    catch(f) {
        return exports.reject(f(this.error));
    }
}
exports.Rejected = Rejected;
class Resolved {
    constructor(value) {
        this.error = undefined;
        this.value = value;
    }
    get isResolved() {
        return true;
    }
    get isRejected() {
        return false;
    }
    then(f) {
        return exports.resolve(f(this.value));
    }
    catch(_f) {
        return exports.resolve(this.value);
    }
}
exports.Resolved = Resolved;
